<template>
    <div>
        <div class="d-flex justify-content-between align-items-center" :class="{ 'mb32': this.isMobile, 'mb16': !this.isMobile }">
            <Icon v-if="this.isMobile" name="arrow-left" class="c24" />
            <h4 class="fsp20 lh28 neue mb-0" :class="{ 'flex-grow-1 mr24 text-center': this.isMobile }" id="c-m-pp-3">{{ this.isMobile ? this.$t('components.service.modal.PayPass.5') : this.$t('components.service.modal.PayPass.4') }}</h4>
            <Icon v-if="!this.isMobile" name="close" class="close-icon" @click="this.close"/>
        </div>
        <div class="bg-white rounded12" :class="{ 'p24': !this.isMobile }">
            <div class="mb24">
                <label class="fsp14 lh20 neue-roman mb8">{{this.$t('components.service.modal.PayPass.1')}}</label>
                <InputSimple 
                    type='password'
                    icon="lock"
                    autofocus 
                    :autocomplete="'off'" 
                    id='pay_pass'
                    @updateParentState="this.updateState" hint=''
                    @onEnter="this.submit"
                />
            </div>
            <div class='d-flex' :class="{ 'position-fixed bottom-0 start-0 end-0 bg-white border-t px24 py16': this.isMobile }">
                <Button id="c-m-pp-2" :name="$t('components.service.modal.PayPass.3')" class="h48 equal-width mr16" :disabled="!this.pass" type='btn-warning' v-on:click='this.submit'/>
                <Button id="c-m-pp-1" :name="$t('components.service.modal.PayPass.2')" class='h48 equal-width' type='btn-outline-grey' v-on:click='this.close'/>
            </div>
        </div>
    </div>
</template>

<script>
import Button from '@/components/service/Button';
import Input from '@/components/service/Input';
import Icon from '@/components/icons/Icon';
import InputSimple from '@/components/service/InputSimple';

export default {
    components: {
        Button,
        Input,
        Icon,
        InputSimple
    },
    props: {
        close: [Function],
    },
    data () {
        return {
            pass: false, 
        }
    },
    computed: {
        isMobile() {
            return this.$store.state.resize.w <= 768;
        }
    },
    methods: {
        updateState(state) {
            this.pass = state.value;
        },
        submit() {
            this.$store.commit('PAY_PASS', this.pass);
            let callback = this.$store.state.modal.content.callback;
            this.$store.commit('MODAL', {
                        action: false,
                        type: false,
                        content: false
                    })
            this.$store.commit('DARK_WRAPPER', false);
            callback();
        }
    },
}
</script>